import { useEffect } from 'react';
// redux
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { SeccionState } from '../../../../store/slices/seccion';
import { BloqueState } from '../../../../store/slices/bloque';
// Reveal
import Reveal from 'reveal.js';
// imagenes
import logoMATUC from '../../../../img/logo_matuc.png';
// LaTeX
import Latex from 'react-latex-next';

import '../../../../css/reveal.css';
import '../../../../css/math.css';
import '../../../../css/diapositivas.css';

type Props = {
    seccionesBloque: Array<SeccionState>
    bloque: BloqueState
    scale: number
    setScale: any
}

const Diapositivas = ({ seccionesBloque, bloque }: Props) => {

    const { curso } = useSelector((state: RootState) => state.curso);

    useEffect(() => {

        const deck = new Reveal({
            // hash: true,
            controlsLayout: 'edges',
            center: false,
            backgroundTransition: 'slide',
            transition: 'slide',
            margin: 0.05,
            width: '1280',
            height: '800',
            minScale: 0.2,
            maxScale: 2.0
        })

        deck.initialize({

        });
        console.log('initialized fool')

    }, [seccionesBloque])

    return (
        <div className="reveal"
            style={{
                background: '#f7f2d3',
                backgroundColor: '#f7f3de'
            }}
        >
            <div className="slides">

                {/* PORTADA */}

                <section data-transition="slide" className='center' >

                    <div className="row align-items-center justify-content-center">
                        <div className="col-6">
                            <h1 style={{ fontSize: '2.5em', marginBottom: '1em' }}>{curso.nombre}</h1>
                            <Latex>{`<h4 style="font-size: 1.3em">${bloque.nombre}</h4>`}</Latex>
                        </div>
                        <div className="col-6 text-center">
                            {/* <img src={logoMATUC} alt="logo uc" width="500" /> */}
                        </div>
                    </div>

                </section>

                {
                    seccionesBloque.map(seccion => {
                        const { diapositivas } = seccion;
                        return diapositivas?.map(item => {
                            const { pagina, contenido } = item;
                            return (
                                <section
                                    data-transition="slide"
                                    data-align='center'
                                    style={{ display: 'block', textAlign: 'justify' }}
                                    key={pagina}
                                >
                                    <Latex>{contenido}</Latex>
                                </section>
                            )
                        })
                    })
                }

            </div>
        </div>
    )
}

export default Diapositivas